/* Four diagonal stripe capsules lifted from the WAVBEE icon. Used as
   the bottom-right corner decoration on dark v2 hero sections that
   don't take a photographic image. Each instance generates a unique
   SVG gradient id so multiple StripeMotifs on the same page don't
   clobber each other's defs. */

import { useId } from 'react'

interface StripeMotifProps {
  size?: number
  opacity?: number
}

export default function StripeMotif({ size = 360, opacity = 0.28 }: StripeMotifProps) {
  const gradId = useId()
  return (
    <svg viewBox="0 0 200 200" width={size} height={size} aria-hidden="true" focusable="false" style={{ opacity, display: 'block' }}>
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#f99c1c" />
          <stop offset="100%" stopColor="#ee3224" />
        </linearGradient>
      </defs>
      <g fill={`url(#${gradId})`}>
        <rect x="51" y="30" width="18" height="140" rx="9" transform="rotate(-35 60 100)" />
        <rect x="81" y="30" width="18" height="140" rx="9" transform="rotate(-35 90 100)" />
        <rect x="111" y="30" width="18" height="140" rx="9" transform="rotate(-35 120 100)" />
        <rect x="141" y="30" width="18" height="140" rx="9" transform="rotate(-35 150 100)" />
      </g>
    </svg>
  )
}
